module.exports = __webpack_public_path__ + "static/media/img_layout1.07152a41.png";